import { Values, Errors } from './types';
import { useFieldValidation } from './useServerValidation';

export const MAX_LENGTH = 32;

const useSignupCodeValidation = (values: Values): [boolean, boolean, Errors] =>
  useFieldValidation(values, 'signup_code');

export default useSignupCodeValidation;
